export default __webpack_public_path__ + "static/assets/8fb2cd36ab770d430d46aebd60430c2e.png";